export default {
    driver_performance_driverDetail_overview_cases: "Cases",
    driver_performance_driverDetail_overview_view: "View",
    driver_performance_driverDetail_overview_casesId: "Cases Id",
    driver_performance_driverDetail_overview_status: "Status",
    driver_performance_driverDetail_overview_created: "Created",
    driver_performance_driverDetail_overview_piSuccess: "PI Success",
    driver_performance_driverDetail_overview_eventSummary: "Event Summary",
    driver_performance_driverDetail_overview_risk: "Risk",
    driver_performance_driverDetail_overview_count: "Count",
    driver_performance_driverDetail_overview_score: "Score",
    driver_performance_driverDetail_overview_yes: "Yes",
    driver_performance_driverDetail_overview_no: "No",
}